import { Form } from '@remix-run/react'

import styles from '~/styles/shop-login-form.module.css'
import { cn } from '~/utils'

type ShopLoginFormProps = {
  action?: string
  method?: 'get' | 'post'
  value: string
  onChange: (value: string) => void
  label: string
  submitLabel: string
  error?: string
  className?: string
  fieldId?: string
  placeholder?: string
}

export function ShopLoginForm({
  action,
  method = 'post',
  value,
  onChange,
  label,
  submitLabel,
  error,
  className,
  fieldId = 'shop-domain-input',
  placeholder = 'e.g. my-shop-domain.myshopify.com'
}: ShopLoginFormProps) {
  return (
    <Form
      className={cn(styles.form, className || '')}
      method={method}
      action={action}
    >
      <div className={styles.fieldGroup}>
        <label className={styles.label} htmlFor={fieldId}>
          {label}
        </label>

        <div className={styles.controls}>
          <input
            id={fieldId}
            className={cn(styles.input, error ? styles.inputError : '')}
            type="text"
            name="shop"
            value={value}
            onChange={(event) => onChange(event.currentTarget.value)}
            autoComplete="on"
            placeholder={placeholder}
            aria-invalid={Boolean(error)}
            aria-describedby={error ? `${fieldId}-error` : undefined}
          />

          <button className={styles.button} type="submit">
            {submitLabel}
          </button>
        </div>

        {error ? (
          <p id={`${fieldId}-error`} className={styles.error} role="alert">
            {error}
          </p>
        ) : null}
      </div>
    </Form>
  )
}
